<aside class="app-sidebar">
  <div class="sidebar-logo">
    <img src="assets/img/cpeselvape.png" alt="Logo">
  </div>

  <nav class="sidebar-nav">
    <ul>
      <li>
        <a routerLink="/inicio" routerLinkActive="active-link">
          INICIO
        </a>
      </li>
      <li>
        <a routerLink="/consultas" routerLinkActive="active-link">
          <i class="material-symbols-outlined">help_outline</i> 
          Consultas
        </a>
      </li>
      <li>
        <a routerLink="/reportes" routerLinkActive="active-link">
          <i class="material-symbols-outlined">description</i> 
          Reportes
        </a>
      </li>
      <li>
        <a routerLink="/configuracion" routerLinkActive="active-link">
          <i class="material-symbols-outlined">tune</i> 
          Configuracion
        </a>
      </li>
    </ul>
  </nav>
</aside>